import Handler from "../Handler";

class RefreshTableDataHandler extends Handler {
    execute(message) {
    //refreshTableData#{
    //   "tableId": "TBL002",
    //   "gameDefId": 202,
    //   "minimumBuyIn": 200.0,
    //   "maximumBuyIn": 1000.0,
    //   "averageChipsStack": 600.0,
    //   "seatedPlayerCount": 4,
    //   "maximumPlayers": 8,
    //   "waitListCount": 2,
    //   "seatedPlayerDetails": {
    //     "player1": {
    //       "playerName": "Dave",
    //       "profileImageUrl": "https://example.com/images/dave.png",
    //       "atTableChips": 700.0,
    //       "position": 1,
    //       "positionName": "Dealer"
    //     },
    //     "player2": {
    //       "playerName": "Eve",
    //       "profileImageUrl": "https://example.com/images/eve.png",
    //       "atTableChips": 800.0,
    //       "position": 2,
    //       "positionName": "Small Blind"
    //     },
    //     "player3": {
    //       "playerName": "Frank",
    //       "profileImageUrl": "https://example.com/images/frank.png",
    //       "atTableChips": 500.0,
    //       "position": 3,
    //       "positionName": "Big Blind"
    //     },
    //     "player4": {
    //       "playerName": "Grace",
    //       "profileImageUrl": "https://example.com/images/grace.png",
    //       "atTableChips": 400.0,
    //       "position": 4,
    //       "positionName": "UTG"
    //     }
    //   },
    //   "totalGamesDurationInHours": 3.0,
    //   "totalGamesOnTable": 15,
    //   "averageGamesPerHour": 5,
    //   "flopsSeenOnTable": 45,
    //   "potValueOnTable": 1500.0,
    //   "flopsSeenPercent": 75.0,
    //   "averagePotValue": 100.0
    // }
    let receivedData = JSON.parse(message);
    console.log("RefreshTableDataHandler received data:", receivedData);
    this.service.processRefreshTableData(receivedData);
  
    }
}
export default RefreshTableDataHandler;